import { AppConfigProvider } from "../../context";
import { AppSpinner } from "../../components/AppSpinner";
import Layout from "../../components/Layout";
import { AnimatePresence } from "framer-motion";
import { ISSBPlan } from "./index";
import { useIsFetching } from "react-query";
import Sidebar from "../../components/Layout/Sidebar";
import { ChakraProvider } from "@chakra-ui/react";
import EsgTheme from "../../theme";
import { NavbarProvider } from "../../components/Layout/Navbar/NavbarProvider";
import PublicNavbar from "../../components/Layout/Navbar/PublicNavbar";

/**
 * Sales lead prospecting tool
 */
const IssbPlanPublic = () => {
  const fetchingQueries = useIsFetching();

  return (
    <>
      <AppConfigProvider>
        <AppSpinner isDefaultShown={fetchingQueries > 0} />
        <NavbarProvider>

          <Layout
            sidebar={
              <ChakraProvider theme={EsgTheme}>
                <Sidebar />
              </ChakraProvider>
            }
            navbar={
              <PublicNavbar />
            }
          >
            <AnimatePresence presenceAffectsLayout exitBeforeEnter>
              <ISSBPlan />
            </AnimatePresence>
          </Layout>
        </NavbarProvider>
      </AppConfigProvider>    </>
  );
};

export default IssbPlanPublic;